import React from 'react';

type TStorageIcon = {
  className?: string;
  style?: any;
  color?: string;
};

export const ResizeIcon: React.FC<TStorageIcon> = ({ className, style, color }) => (
  <svg
    className={className}
    style={style}
    width="46px"
    height="46px"
    viewBox="0 0 24.00 24.00"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#5f595e"
    transform="matrix(1, 0, 0, 1, 0, 0)rotate(0)"
  >
    <g id="SVGRepo_bgCarrier" stroke-width="0" transform="translate(4.32,4.32), scale(0.64)">
      <rect x="0" y="0" width="24.00" height="24.00" rx="6" fill="#4e46b4"></rect>
    </g>
    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.096"></g>
    <g id="SVGRepo_iconCarrier">
      {' '}
      <path
        d="M14 15L17 12L14 9M10 9L7 12L10 15"
        stroke="#ffffff"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>{' '}
    </g>
  </svg>
);
